module.exports = __webpack_public_path__ + "media/_archive/M-1d8df713.png";